import Vue from 'vue'
import Vuex from 'vuex'
import dict from './modules/dict'
import dept from './modules/dept'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    dict,
    dept,
  },
  getters
})

export default store
